module.exports = __webpack_public_path__ + "img/mu.d6db35bc.svg";